import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { UnknownRights } from "src/pages/Admin/UnknownRights/Type";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

export async function getSecuritiesRequest(term: string, filter?: string) {
	return await apiClient
		.get(API.QUERY.ADMIN.SECURITIES_FINDER(term, "STOCK"))
		.then((res) => res.data);
}

async function getUnknownRightsRequest() {
	return await apiClient.get(API.QUERY.ADMIN.UNKOWN_RIGHTS).then((res) => res.data);
}

export function useGetUnknownRights() {
	return useQuery<UnknownRights[], AxiosError>({
		queryKey: ["adminUnknownRights"],
		queryFn: () => getUnknownRightsRequest(),
		initialData: []
	});
}
